export default (context, html) => html`
<div id="academy-video-container">
<video id="academy-video" @ended="${(e) => context.handleClose(e)}" @fullscreenchange="${(e) => context.handleFullscreenchange(e)}" src=${window?.aofljsConfig?.__prerender__ === true ? '' : context.videoSrc} controls controlsList="nodownload"></video>
  <div id="svg-wrapper" @click="${(e) => context.handleClose(e)}">
    <span class="close-button"></span>
  </div>
</div>
`;
